import styled from 'styled-components';

const Pseudos = styled.div`
  display: flex;
  flex-wrap: wrap;

  div {
    width: 48%;
    background: hsl(9, 48%, 95%);
    font-weight: bold;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    padding: 0.5rem;
    margin: 0 0.25rem 0.25rem 0;
  }
`;

const SmallHeader = styled.h3`
  font-weight: bold;
  margin: 1rem 0;
`;

const Text = styled.p`
  margin: 1rem 0;
`;

export { Text, SmallHeader };

export default Pseudos;
